export class Aggregato{
    id:number;
    name:string;
    codice:string;

    tipologiaIntervento: any;
}